import React from 'react';

//attachFileAccount__message
const InfoCard = ({ icon, customClasses, content }) => {
  return (
    <div className={`infoCard ${customClasses || ''}`}>
      <div className="infoCard__icon">
        <img src={icon} alt="icon" />
      </div>
      <div className="infoCard__content">{content}</div>
    </div>
  );
};

export default InfoCard;
